import React, { FunctionComponent, ReactElement } from "react";
import RevealUp from "../../../components/animations/RevealUp";

const OthelloSkeleton: FunctionComponent = (): ReactElement => {
    return (
        <>

        </>
    );
};

export default OthelloSkeleton;
